export const CONTRACT = {
    COMPANY: '梁山股份有限公司',
    NAME: '消費者媒合服務協議',
    LAST_UPDATED_AT: '最新更新日期：2023年10月12日',
    TERMS: [
        {
            title: '一 、一般定義',
            list: [
                '此為梁山股份有限公司（以下簡稱「本公司」）與您締結之消費者媒合服務協議（以下簡稱「本協議」），本公司所提供之其他服務契約亦構成本協議之一部分，與本協議具同一效力。',
                '本公司為提供非醫療照顧服務媒合平台服務（以下簡稱「本服務」）。非醫療照顧服務指非屬醫療行為之照護服務。',
                '本公司為「Home心照護媒合平台」（以下簡稱「本平台」）之設計者、所有者及維護者，提供相關平台給予客戶使用，並藉由本平台進行客戶與照顧服務專員（以下簡稱「照服員」）間的照護媒合服務。',
                '當您開始使用本服務時，即表示已閱讀、瞭解並同意接受本服務條款之所有內容，且完全接受本服務現有與未來衍生的服務項目及內容與後續修訂。',
                '本平台將遵守個人資料保護法之規定，蒐集、處理及利用您與照護對象之個人資料。',
            ],
        },
        {
            title: '二、服務須知',
            list: [
                '您了解並知悉本服務所媒合之照服員提供之照護服務非醫療行為，無法替換任何專業醫療建議。',
                '媒合經由您與照服員雙方確認後即成立，您與照服員間將直接成立照護服務契約關係，您應與照服員自行議定照護契約關係之內容，並以之作為與照服員相關權利、義務事項之約定。',
                '本公司為媒合照服員與照護需求者雙方服務之第三方平台，您暸解且同意於平台生效之訂單，均獨立於本平台外，本公司非照護契約關係當事人、照護服務承包商，本公司是平台技術服務提供商，並不提供或參與任何照護服務。',
                '本公司與照服員間並無任何僱傭、委任、承攬、派遣或勞動關係，本公司對於照服員亦無任何選任、指揮、監督或管理之權限、義務與行為。',
                '本公司無法保證您於本平台提出之需求必能媒合到照服員，媒合之結果需視需求時段、地點、病症及照服員個人之意願而定。',
                '您於平台提出服務需求時，應如實填寫照顧需求者症狀。若照服員抵達現場時，發現實際症狀與您提出之需求不符（包括但不限於：服務類別、工作項目、狀況描述等）並無法對應，照服員得拒絕提供照護服務，且您需負擔照服員取消費新台幣200元（本公司得不時調整取消費金額，適用之取消費金額悉依系統顯示為主），本平台亦有權對您依照平台相關規定進行終止使用權限或違約處分。',
                '您瞭解並同意，照護服務若屬需有醫囑之行為（包括但不限於更換鼻胃管、氣切管、導尿管等），您應事前備妥醫囑，於照服員實際提供服務時出具該醫囑，並告知照服員相關應注意事項。如無法提供醫囑，照服員依法得拒絕提供需有醫囑之特定照護服務，且您不得以之為由向本公司請求退款。',
                '如您本人非受照顧對象，您須為受照護對象之配偶或三等親內之親屬，知悉受照護對象之需求，並取得受照護對象之同意，以利服務進行。',
            ],
        },
        {
            title: '三、平台用戶的權利義務',
            list: [
                '您瞭解並知悉本平台用戶應有完全之行為能力。若您未滿十八歲，或為其他依法未具備完全行為能力者，應請法定代理人（或監護人）陪同閱讀本協議，在法定代理人（或監護人）詳讀、瞭解並同意本協議後，方能使用或繼續使用本服務。當您使用或繼續使用本服務時，即代表法定代理人（或監護人）已詳讀、瞭解並同意接受本協議的所有內容及其後續不時修改或變更之更新版本。',
                '為了提供確實有效之服務，您必須保證所提供予本公司及本平台之所有資料，均屬完整、正確、與實際情況相符之資料。如有事後變更之情形，為保障雙方及照服員權利，您應即時修改留存於本平台之資料。',
                '若您於本平台所提供之任何資料屬於錯誤、不實、不完整或不精確之資料，您除必須自行負擔所造成之損失與不利益外，本公司亦有權暫停或終止您對本服務的使用。',
            ],
        },
        {
            title: '四、協議或服務的變更',
            list: [
                '本公司將依照本協議第十六條所定條款為本協議條款變更及修改之通知，包括但不限於收費費率之變更。',
                '所有因您使用本服務而與本公司所生的權利義務關係，均以最新修訂之條款內容為依據。如您不願接受條款修改，應於受通知後立即停止使用本服務。',
                '如您在條款修改公告後仍繼續使用本平台及本服務，視為您同意修改後的條款。',
            ],
        },
        {
            title: '五、收費方式',
            list: [
                '本平台所配合照服員之收費方式以系統顯示之金額為準，可參考派案最後的訂單確認畫面顯示之試算金額。',
                '收費內容包含但不限於照服員照顧費用、平台使用費、取消費與系統手續費。',
                '服務開始及結束時間之計算，依您在本平台所收到照服員上工/下工訊息之時間為基準，若您與照服員皆同意以其他方式計算服務時間，本平台會盡力協助您做處理。',
                '照服員照顧費用包含但不限於基本照顧費用、特殊病床加價項目、特殊疾病加價項目、特殊照顧服務加價項目，以家屬派案時系統顯示金額為準。',
                '您如欲於訂單媒合成功一小時後始取消訂單，需依系統顯示規定支付取消費並須於限期內繳清取消費用新台幣200元（本公司得不時調整取消費計算規則及金額，適用之取消費計算規則及金額悉依系統顯示為主）。此外，在尚未繳清取消費前，本公司有權暫停本服務之提供，您將無法重新進行照服員媒合。',
            ],
        },
        {
            title: '六、付款方式',
            list: [
                '您瞭解並知悉您使用本公司所提供之服務費用。本公司將根據本協議約定之服務費用於服務完成後，以信用卡或網路ATM方式向您收取。',
                '本公司將使用第三方服務處理信用卡資訊及其他線上支付方式。',
                '您需依照系統指示完成付款，超過付款期限者，本公司可能酌收系統手續費，費用依當下系統顯示金額為主，且費用得以累計。',
            ],
        },
        {
            title: '七、替代照顧服務',
            list: [
                '當照服員無法進行預訂之照顧時，本公司在接獲提前通知情況下，將盡力協助在短時間內尋找替代照服員。',
                '若無其他照服員可供替代，您將不會被收取服務費。惟本公司不為無法提供替代照服員負賠償責任。',
            ],
        },
        {
            title: '八、優惠促銷',
            list: [
                '您可能會接獲優惠或促銷通知（根據本公司自行決定），而此類優惠或促銷將可能受到某些附加條款約束。',
                '優惠或促銷活動亦可能無法與任何其他優惠相結合，悉依實際公布之優惠或促銷內容為準。',
            ],
        },
        {
            title: '九、運輸免責聲明',
            list: [
                '如在照顧服務必要範圍時，照服員乘坐或使用您或受照護對象之車輛，您將負擔所有的相關意外及賠償責任，而與本公司無涉。',
                '若您或受照護對象乘坐或使用照服員的車輛，本公司不承擔任何因使用或乘坐照服員的車輛而造成的任何損害及賠償責任。',
            ],
        },
        {
            title: '十、評級',
            list: [
                '當您或受照護對象被要求提供照服員的評級時，您同意所有評級將代表提供評級的人獨立、誠實及真實的意見。',
            ],
        },
        {
            title: '十一、緊急救助免責聲明',
            list: [
                '本服務所媒合照服員提供之服務不包括任何形式的醫療行為。若受照護對象發生緊急情況，本公司對於照服員的任何作為或不作為所造成的任何損害概不負責。',
                '照服員是否提供緊急處理是由照服員自行決定，若有進行緊急處理，您將須另行支付與該緊急處理相關的額外費用。',
            ],
        },
        {
            title: '十二、隱私和保密',
            list: [
                '您於本平台提交有關您和受照護對象之個人資訊，如姓名、地址、手機號碼和年齡，以及可能與照顧服務相關的資訊，例如身體或精神狀況、藥物、偏好、飲食需求或禁忌等。您須保證所提供或留存的所有資料均屬完整、正確且與實際情況相符，如有變更，應即時修改留存於本平台之資料。',
                '您瞭解並同意，在不揭露隱私資料之前提下，本平台有權對本平台上之資料進行分析，並對該資料庫進行商業上之利用。',
                '本公司亦可能會按照本公司的隱私政策，將您授予我們的照顧服務相關資訊和您授權的其他人（包括其他家庭成員或受照護對象的醫療團隊成員）分享。',
                '資訊服務平台或網站伺服器所記錄使用者上網的IP位址、上網時間以及在網站內所瀏覽的網頁等資料，以及使用第三方服務提供的分析工具，例如Google Analytics 和Hotjar 提供的服務，用以瞭解使用者於本網站內滑鼠點擊、移動、捲動視窗之行為。僅供本公司網站管理單位內部作網站流量和網路行為調查的總量分析，以利於提昇其服務品質。被蒐集的資料將由第三方服務軟體處理及利用並保存於其伺服器上，第三方服務軟體將透過 Cookie 及其他技術蒐集的資訊包含：您瀏覽網站的設備之 IP 位置（僅以匿名格式處理及利用）、設備類型及瀏覽器、設備所在國家、網頁瀏覽使用的語言等。如需更詳細的資訊，請參閱 Hotjar 的隱私權政策（https://www.hotjar.com/privacy），若您希望停止 Hotjar 的記錄功能，可至以下網址取消：https://www.hotjar.com/opt-out，或來信告知本公司，我們將協助您操作。',
                `由於個人資料之蒐集，涉及您和受照護對象的隱私權益，茲依個人資料保護法（以下稱個資法）規定，告知您和受照護對象下列事項：
(1) 個人資料蒐集之目的：
您瞭解並同意本公司蒐集您的個人資料係包括但不限於供下列特定目的之利用：
○四○：行銷（包含金控共同行銷業務）；○六三：非公務機關依法定義務所進行個人資料之蒐集處理及利用；○六七：信用卡、現金卡、轉帳卡或電子票證業務；○六九：契約、類似契約或其他法律關係事務；○九○：消費者、客戶管理與服務；○九一：消費者保護；一四八：網路購物及其他電子商務服務；一五二：廣告或商業行為管理（例如：提供相關優惠行銷活動）；一五七：調查、統計與研究分析；一八一：其他經營合於營業登記項目或組織章程所定之業務；及一八二：其他諮詢與顧問服務。
(2) 個人資料之類別：
您瞭解並同意本公司所蒐集、處理、利用或國際傳輸您的個人資料，包括但不限於：
Ｃ○○一：辨識個人者（例如：姓名、住址、電子郵件信箱地址、行動電話、網路平臺申請之帳號、相片等）；Ｃ○○二：辨識財務者（例如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、保險單號碼、個人之其他號碼或帳戶等）；Ｃ○○三：政府資料中之辨識者（例如：身分證統一編號、證照號碼等）；Ｃ○一一：個人描述（例如：出生年月日、性別、年齡等）；C○一二：身體描述（例如：身高、體重、血型等）；C○一三：習慣（例如：抽煙、喝酒等）；C○一四：個性（例如：個性等之評述意見）；Ｃ○三八：職業；Ｃ一一一：健康紀錄（例如：醫療報告、治療與診斷紀錄、檢驗結果、身心障礙種類、等級、有效期間、身心障礙手冊證號及聯絡人等）。
(3) 個人資料利用之期間：
除另有約定者外，本公司將於您本協議有效存續期間內，處理、利用或國際傳輸您的個人資料。  
(4) 個人資料利用之地區：
本公司及本服務個人資料主機、相關網路伺服器主機所在地及本平台相關服務提供或行銷地區，為您個人資料利用之地區。
(5) 個人資料利用之對象：
本公司、本公司關係企業、相關委外之合作夥伴及瀏覽本服務客戶，為您個人資料利用之對象。
(6) 個人資料利用之方式：
您提供予本公司之個人資料，將由本公司於本服務個人資料主機、相關網路伺服器主機中妥善保存，並以符合個人資料保護相關法令以自動化機器或其他非自動化之利用方式利用之，包括但不限於針對您提供予本公司之個人資料進行分析，並就分析結果向您提供或推薦經優化的相關互動性資訊。
(7) 個人資料權利及行使方式告知：
對於您的個人資料，您可以聯繫我們[service@homexin.com]行使下列之權利：
a. 查詢或請求閱覽、補充或更正您的個人資料；
b. 請求停止蒐集、處理或利用您的個人資料；
c. 請求刪除您的個人資料；及
d. 請求製給您個人資料的複製本。
(8) 為確保您之個人資料、隱私及權益之保護，當您於本平台輸入個人資料時，即表示您願意以本條規定行使法律所賦予同意之權利。如您不同意註冊並輸入您個人資料時，可能會無法使用本平台所提供之特定服務。
(9) 個人資料之法定揭露：
當使用者可能違反本協議或是損害本公司或第三人權益，或因法律或司法單位要求本公司提供特定使用者之個人資料時，本公司將在合法的程序下進行讀取、使用或揭露。
        `,
                '您確認並保證您已向受照護對象告知本條所揭有關其個人資料保護之相關權利並取得受照護對象之同意：同意您向本公司揭露其個人資料，並同意本公司就受照護對象之個人資料可為本第十二條所載之蒐集、處理、利用行為。若您揭露之資訊涉及受照護對象之病歷、醫療、基因、性生活、健康檢查及犯罪前科之個人資料，您並應取得受照護對象之書面同意。若本公司因蒐集、處理、利用受照護對象之個人資料而遭第三方請求或遭主管機關裁罰，您同意賠償本公司因之所受之一切損害（包括但不限於訴訟費、律師費、罰鍰、罰金及給付予第三人之賠償）。',
            ],
        },
        {
            title: '十三、通訊',
            list: [
                '您同意您和受照護對象收到來自本公司和照服員的電話、手機簡訊、電子郵件和平台通知。您的電信公司可能會對這些電話和簡訊收取相關費用。',
                '您還可能收到本公司或關懷專員的電子郵件，包括有關受照護對象的資訊，有關服務、簡報、特別優惠和帳戶提醒和更新。您可以按照電子郵件中的說明，取消訂閱部分通訊。',
                '如果您不想通過電子郵件接收敏感或機密資訊的通訊，請透過service@homexin.com通知我們。',
            ],
        },
        {
            title: '十四、免責聲明暨賠償責任限制',
            list: [
                '您於使用本服務及本平台所提供之資訊服務前，應自行判斷、評估並自負風險，並確保資訊之正確性、可信性及完整性等，本公司不負任何擔保責任。',
                '本服務出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤、遭人篡改或其他經濟上損失等情形，您應於使用時自行採取防護措施，本公司概不負責。',
                '您不得向本公司主張，經由本公司所取得之任何資料、服務或其他資訊，未符合您的要求、期望或有任何瑕疵。',
                '本公司無保證本平台不受干擾、及時提供、安全可靠或免於出錯。您自本公司或經由本平台所取得之資訊和建議，無論其為書面或口頭，均不構成本公司之保證。本公司對於您因使用（或無法使用）本平台而造成的損害，不負任何賠償責任。',
                '除本協議另有規定外，本公司不對您任何直接或間接之損害負責（包含但不限於資訊中斷、數據遺失、替代服務費用、人身或財產損害或與之相關的損失）。',
                '本公司與本協議相關的所有責任賠償額度，以本公司為涉及賠償責任之單一服務案件已向您收取之服務費用為上限。',
            ],
        },
        {
            title: '十五、適用法律',
            list: [
                '本協議之準據法為中華民國法律，應依中華民國法律解釋適用，不考慮其衝突法規定。由本協議所生或有關於本協議之任何糾紛、爭議或主張，如雙方無法和平地達成共識時，雙方同意應以臺灣臺北地方法院為第一審管轄法院。',
            ],
        },
        {
            title: '十六、通知',
            list: [
                '本公司得透過平台上的一般通知或電子郵件發送訊息至您提供的電子郵件地址，或透過實體郵件發送書面訊息到您所留存的地址。',
                '此類通知應在郵寄發出後48小時（透過實體郵件發送時）或電子發送後12小時（透過電子郵件發送時）生效，您不得以通知未確實送達抗辯其效力。',
                '您亦可以透過本公司之電子郵件service@homexin.com.tw與本公司聯繫。',
            ],
        },
        {
            title: '十七、其他',
            list: [
                `本公司得在未經您同意的情況下，轉讓本協議予：（i）本公司之附屬公司或附屬機構;（ii）本公司全部或主要股權，業務或資產的收購方，或（iii）與本公司合併後之新設或存續公司。
除前述情形外，任何違反本條規定的轉讓行為均屬無效。
        `,
                '如果本協議的任何規定被視為無效或不可執行，應當依該規定之內容在法律允許的最大範圍內予以執行。',
                '當本公司未能執行本協議中的任何權利或規定，不構成對該權利或規定的放棄，除非獲得本公司書面同意。',
            ],
        },
        {
            title: '十八、智慧財產權',
            list: [
                '本平台所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、介面的安排、介面設計等，除本平台或網站有特別規定外，均由本公司或其他權利人依法擁有其智慧財產權。',
                '前項所述智慧財產權包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得未經同意，擅自使用、修改、破壞、更改、妨礙正常使用、重製、公開播送、改作、散佈、出租、發行、公開傳輸、公開發表、進行還原工程、解編或反向組譯。尊重智慧財產權是您應盡的義務，如有違反，您應自負一切法律責任並應對本公司負損害賠償責任。',
                '為保障他人之智慧財產權，若您認為您的商標權、專利權、著作權等智慧財產權有受本網站侵害之虞，請盡速與本公司聯絡，並提供侵害智慧財產權之具體資料予本公司，包括但不限於(1) 所主張遭到侵害之智慧財產權之描述；(2) 所主張遭侵害您權利之著作物於本網站所在位置之敘述；及(3) 您的聯絡方式等。',
            ],
        },
    ],
    FOOTER: `透過按下「同意」按鈕，您明確確認，您已閱讀、理解及充分考慮本協議之內容，您同意受本協議的條款和條件之拘束，您在法律上有與本公司簽署本協議之完全行為能力。`,
};
